"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getTextWidth = void 0, exports.getTextWidth = function () {
  var r = document.createElement("canvas");
  return function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : .5;
    var o = null != e ? e : "";
    o = o.toString();
    var n = r.getContext("2d");
    return n ? (n.font = window.getComputedStyle(document.body).getPropertyValue("font"), n.measureText(o).width) : parseFloat(window.getComputedStyle(document.body).getPropertyValue("font-size")) * t * o.length;
  };
}();